function AddFilterSortProduct(params, dataFilter, dataSort) {
  let qs = Object.assign({}, params)

  if (dataFilter.searchKey) {
    qs.where.or = [
      { email: { like: `${dataFilter.searchKey}%` } },
      { profileId: { like: `${dataFilter.searchKey}%` } },
      { name: { like: `${dataFilter.searchKey}%` } },
    ]
  }

  if (dataFilter.createdStartDate) {
    qs.where.createdAt = {}
    if (dataFilter.createdStartDate) {
      qs.where.createdAt['>='] = dataFilter.createdStartDate
    }
    if (dataFilter.createdEndDate && dataFilter.isCreatedEndDateActive) {
      qs.where.createdAt['<='] = dataFilter.createdEndDate
    }
  }

  if (dataFilter.updatedStartDate) {
    qs.where.updatedAt = {}
    if (dataFilter.updatedStartDate) {
      qs.where.updatedAt['>='] = dataFilter.updatedStartDate
    }
    if (dataFilter.updatedEndDate && dataFilter.isUpdatedEndDateActive) {
      qs.where.updatedAt['<='] = dataFilter.updatedEndDate
    }
  }

  if (dataSort.active) {
    qs.sort = {
      isEligible: 'DESC',
      [dataSort.active]: dataSort[dataSort.active]
    }
  }

  if (dataFilter.country) {
    qs.where.country = dataFilter.country
  }

  if (dataFilter.service) {
    qs.where.service = dataFilter.service
  }

  if (dataFilter.publishStatus !== '') {
    qs.where.isPublished = dataFilter.publishStatus
  }

  if (dataFilter.status !== '') {
    qs.where.status = dataFilter.status
  }

  if (dataFilter.productType) {
    qs.where.productType = dataFilter.productType
  }

  if (dataFilter.format) {
    qs.where.format = dataFilter.format
  }

  return qs
}

export default AddFilterSortProduct

